'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.key = key;
exports.quantity = quantity;
exports.id = id;
exports.properties = properties;
exports.options = options;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */

function key(key) {
  if (typeof key !== 'string' || key.split(':').length !== 2) {
    throw new TypeError('Theme Cart: Provided key value is not a string with the format xxx:xxx');
  }
}

function quantity(quantity) {
  if (typeof quantity !== 'number') {
    throw new TypeError('Theme Cart: An object which specifies a quantity or properties value is required');
  }
}

function id(id) {
  if (typeof id !== 'number') {
    throw new TypeError('Theme Cart: Variant ID must be a number');
  }
}

function properties(properties) {
  if ((typeof properties === 'undefined' ? 'undefined' : (0, _typeof3.default)(properties)) !== 'object') {
    throw new TypeError('Theme Cart: Properties must be an object');
  }
}

function options(options) {
  if ((typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) !== 'object') {
    throw new TypeError('Theme Cart: Options must be an object');
  }

  if (typeof options.quantity === 'undefined' && typeof options.properties === 'undefined') {
    throw new Error('Theme Cart: You muse define a value for quantity or properties');
  }

  if (typeof options.quantity !== 'undefined') {
    quantity(options.quantity);
  }

  if (typeof options.properties !== 'undefined') {
    properties(options.properties);
  }
}